import { Breadcrumb, type BreadcrumbItem } from '../../shared/ui';
import { ReactNode } from 'react';

interface PageProps {
  children: ReactNode;
  breadcrumbItems: BreadcrumbItem[];
  isLoading?: boolean;
}

export const Page = ({ children, breadcrumbItems, isLoading }: PageProps) => {
  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb items={breadcrumbItems} />

      {isLoading ? (
        <div className="rounded-lg bg-white p-6 shadow">
          <div className="text-center text-gray-600">Загрузка…</div>
        </div>
      ) : (
        children
      )}
    </div>
  );
};
